import { Type } from "@angular/core";

export abstract class EntityBuilderItem {
    component: Type<any>;
    data: any;
    createComponent(prop: any, isForm: boolean, componentData: any) { };
}